import { useEffect, useState } from 'react';

import { Group, Loader, Text } from '@mantine/core';

import { IconCheck } from '@tabler/icons-react';
import type { UseMutationResult } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export function MutationFeedback({
  mutations,
}: {
  mutations: UseMutationResult<any, Error, any, any>[];
}) {
  const { t } = useTranslation('shared');
  const [isSaved, setIsSaved] = useState(false);

  useEffect(() => {
    if (mutations.some(m => m.isSuccess)) {
      setIsSaved(true);
      const timer = setTimeout(() => {
        setIsSaved(false);
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, [mutations]);

  if (mutations.some(m => m.isPending)) {
    return (
      <Group noWrap spacing="01" align="center">
        <Text variant="xs" fw={500} c="gray.5" sx={{ whiteSpace: 'nowrap' }}>
          {t('mutationFeedback.pending')}
        </Text>
        <Loader size={12} />
      </Group>
    );
  }

  if (isSaved)
    return (
      <Group noWrap spacing="01" align="center">
        <Text variant="xs" fw={500} c="gray.5" sx={{ whiteSpace: 'nowrap' }}>
          {t('mutationFeedback.success')}
        </Text>
        <IconCheck size={12} />
      </Group>
    );

  return null;
}
